export default class Avatar extends PIXI.Container {
    constructor(texture) {
        super();

        this._view = new PIXI.Sprite(texture);
        this._view.anchor.set(0.5, 1);
        this.addChild(this._view);
    }

    update(dt) {
    }

    get view() {
        return this._view;
    }
}

Avatar.CLASS_KNIGHT_1   = "knight1";
Avatar.CLASS_KNIGHT_2   = "knight2";
Avatar.CLASS_KNIGHT_3   = "knight3";
Avatar.CLASS_KNIGHT_4   = "knight4";